import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { AgencyGridViewModel } from '@program-suite/data-common';

@Injectable({
  providedIn: 'root',
})
export class AgencyGridService {
  http = inject(HttpClient);

  /**
   * get agency grid
   * @returns 200 - OK(AgencyGridViewModel)
   * @throws Error if fails
   */
  async getAgencyGrid(params: any): Promise<AgencyGridViewModel> {
    try {
      return await firstValueFrom(this.http.get('Agency/agencies', { params, responseType: 'json' }));
    } catch (error) {
      throw new Error('Something went wrong, please try again');
    }
  }
}
